module.exports = __webpack_public_path__ + "static/media/bell.85582d75.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/bell.gif
// module id = 1014
// module chunks = 0